<div
  class="munily-toggle-panel"
  [ngClass]="panelClasses"
>
  <div class="munily-toggle-panel__row">
    <div class="munily-toggle-panel__text">
      <span class="munily-toggle-panel__state-label">{{ displayLabel }}</span>
      <p *ngIf="hasSubtitle" class="munily-toggle-panel__subtitle">
        {{ subtitle }}
      </p>
    </div>
    <div class="munily-toggle-panel__control">
      <span class="munily-toggle-panel__toggle-state s1_500">
        {{ (checked ? 'adverb.yes' : 'adverb.no') | translate }}
      </span>
      <common-toggle
        [checked]="checked"
        [disabled]="disabled"
        (change)="onToggleChange($event)"
      ></common-toggle>
    </div>
  </div>

  <div
    *ngIf="shouldShowFooter && footerTemplate"
    class="munily-toggle-panel__footer"
    (click)="$event.stopPropagation()"
  >
    <ng-container
      [ngTemplateOutlet]="footerTemplate"
      [ngTemplateOutletContext]="{ $implicit: footerContext }"
    ></ng-container>
  </div>
</div>
